import React from 'react';

const CharacterVoiceActors = ({ voices }) => {
  if (!voices || voices.length === 0) {
    return (
      <div className="tab-content">
        <div className="left-column">
          <p className="no-content">No voice actor information available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div className="left-column">
        {voices.map((voice, index) => (
          <div key={index} className="voice-actor-card">
            <div className="voice-actor-image">
              <img src={voice.person.images?.jpg?.imageUrl} alt={voice.person.name} />
            </div>
            <div className="voice-actor-info">
              <h4>{voice.person.name}</h4>
              <p className="text-secondary">{voice.language} Dub</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CharacterVoiceActors;